if (document.querySelector('.no--urls')) { 
    const nourls = document.querySelectorAll('.no--urls a')
    nourls.forEach(link => { 
        link.href = '/login'
        link.target = "_self"
    })
}

if (document.querySelector('.product__toggle')) {

    // Produktmodal
    const productToggle = document.querySelectorAll('.product__toggle-trigger')
    const closeModal = document.querySelectorAll('.close__modal')

    const closeModalAction = () => {
        productToggle.forEach(toggle => toggle.parentNode.classList.remove('active'))
        document.body.classList.remove('disabled')
    }



    closeModal.forEach(btn => { 
        btn.addEventListener('click', closeModalAction)
    })


    

    // productToggle.forEach(toggle => {
    //     toggle.addEventListener('click', () => { 
    //         document.body.classList.add('disabled')
    //         toggle.parentNode.classList.add('active')
    //     })
    // })

    const openProductToggle = (el) => { 
        document.body.classList.add('disabled')
        el.parentNode.classList.add('active')

    }

    window.addEventListener('keyup',e => {
        if(e.key === "Escape" || e.key === "Esc") closeModalAction()
    })

    // Produktfilter

    const productFilterButton = document.querySelectorAll('.product__filter-button')
    const productData = document.querySelectorAll('.product__items-product')

    productFilterButton.forEach(button => { 
        button.addEventListener('click', e => {
            productFilterButton.forEach(b => b.classList.remove('active'))
            button.classList.add('active')
            const target = e.target.dataset.filter
            console.log(target);
            productData.forEach(product => { 
                product.classList.contains(target) ? product.classList.add('active') : product.classList.remove('active')
                }
            )
        })
    })

}